/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown> }} Sub_Overview_Billed_For_SeatsInputs */



/**
* | output |
* | --- |
* | "billed for {seats} seats" |
*
* @param {Sub_Overview_Billed_For_SeatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_overview_billed_for_seats = /** @type {((inputs: Sub_Overview_Billed_For_SeatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Overview_Billed_For_SeatsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`abgerechnet für ${i?.seats} Plätze`)
	return /** @type {LocalizedString} */ (`billed for ${i?.seats} seats`)
});